import { useState } from "react";
import { getAbsoluteUrl } from "../../../utils/getAbsoluteUrl";

export interface TestimonialDetailsBlock {
  image: string;
  altText: string;
  testimonialText: string;
  personDetails: string;
}

export interface APIResult {
  testimonialsDetails: TestimonialDetailsBlock[];
}

export const useCampaignTestimonials = () => {
  const [testimonials, setTestimonials] = useState<TestimonialDetailsBlock[]>(
    [],
  );
  const [loading, setLoading] = useState(false);

  const getCampaignTestimonials = async () => {
    setLoading(true);
    const result = await fetchLinks();

    if (!result) {
      console.error("Failed to load links.");
      return false;
    }
    const fetchedTestimonials = result.testimonialsDetails;

    setTestimonials(fetchedTestimonials);
    setLoading(false);
  };

  const fetchLinks = async (): Promise<APIResult | null> => {
    try {
      // Use absolute URL base to account for if the URL doesn't end with a forward slash
      const urlBase = getAbsoluteUrl();

      const urlToFetch = `${urlBase}GetTestimonials`;
      const response = await fetch(urlToFetch);
      const data = await response.json();
      return {
        testimonialsDetails: data,
      };
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  return { testimonials, getCampaignTestimonials, loading };
};
